/**
 * The Schorschi panel that opens anywhere in the app (SchorschiPanel.vue,
 * mounted once by the shell): ⌘J / Ctrl+J, the command palette ("Ask
 * Schorschi: …") or a button call `openSchorschi`. It continues the last
 * conversation of this browser session unless told otherwise.
 */

import { reactive } from "vue";

const STORAGE_KEY = "schorschi.panel.conversation";

function remembered(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export const panel = reactive({
  open: false,
  conversationId: remembered(),
  /** Ask this right away when the panel opens (a new conversation). */
  ask: null as string | null,
  /** Put this into the composer when the panel opens. */
  draft: null as string | null,
});

export interface OpenOptions {
  /** A conversation to show (null: a new one); left out: the panel's last one. */
  conversationId?: string | null;
  ask?: string;
  draft?: string;
}

export function openSchorschi(o: OpenOptions = {}): void {
  if (o.conversationId !== undefined) panel.conversationId = o.conversationId;
  if (o.ask?.trim()) {
    panel.conversationId = null;
    panel.ask = o.ask.trim();
  }
  if (o.draft) panel.draft = o.draft;
  panel.open = true;
}

export function closeSchorschi(): void {
  panel.open = false;
}

export function toggleSchorschi(): void {
  if (panel.open) closeSchorschi();
  else openSchorschi();
}

/** The panel's conversation (kept for this browser session). */
export function rememberPanelConversation(id: string | null): void {
  panel.conversationId = id;
  try {
    if (id) sessionStorage.setItem(STORAGE_KEY, id);
    else sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // storage blocked: the panel simply starts fresh next time
  }
}
